export default __webpack_public_path__ + "static/media/wand.eb77cf59.svg";